export function isGenericUser(userTipo) {
    return userTipo === 1 || userTipo === 4;
}

export function isStreamingDeactivatedByPilot(point, userTipo) {
    const streaming = point?.streaming || point?.stream;
    if (!streaming) {
        return false;
    }

    if (!isGenericUser(userTipo)) {
        return false;
    }

    const status = streaming.STATUS ?? streaming.STAT;
    return status === 0;
}
